import { gql } from '@apollo/client'

export const mutationQuery = gql(`
    mutation setRole($filter: JSON!, $input: JSON!) {
        setRole(filter: $filter, input: $input) {
            _id
            roles
        }
    }
`)
